import { DateRangePicker, DateRangePickerItem } from "@tremor/react";

export default function DateRangePickerWidget({ updateDates }) {
    const today = new Date();

    // get current month
    const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    // get current week
    const firstDayOfCurrentWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay());
    const lastDayOfCurrentWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() + 6);

    // get last month
    const firstDayOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const lastDayOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);

    // get last week
    const firstDayOfLastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() - 7);
    const lastDayOfLastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() - 1);

    // get all time 
    const allTime = new Date(2023, 9, 1);

    // get last 30 days
    const last30Days = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30);

    // get yesterday
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    return (
        <DateRangePicker
            className="max-w-sm"
            weekStartsOn={1}
            selectPlaceholder="Custom"
            placeholder="Select date"
            onValueChange={(values) => {
                updateDates(values);
            }}
        >
            <DateRangePickerItem
                key="today"
                value="today"
                from={today}
                to={today}
            >
                Today
            </DateRangePickerItem>
            <DateRangePickerItem
                key="yesterday"
                value="yesterday"
                from={yesterday}
                to={yesterday}
            >
                Yesterday
            </DateRangePickerItem>
            <DateRangePickerItem
                key="last30Days"
                value="last30Days"
                from={last30Days}
                to={today}
            >
                Last 30 Days
            </DateRangePickerItem>
            <DateRangePickerItem
                key="ytd"
                value="ytd"
                from={firstDayOfCurrentMonth}
                to={lastDayOfCurrentMonth}
            >
                Current Month
            </DateRangePickerItem>
            <DateRangePickerItem
                key="half"
                value="half"
                from={firstDayOfCurrentWeek}
                to={lastDayOfCurrentWeek}
            >
                Current Week
            </DateRangePickerItem>
            <DateRangePickerItem
                key="lastMonth"
                value="lastMonth"
                from={firstDayOfLastMonth}
                to={lastDayOfLastMonth}
            >
                Last Month
            </DateRangePickerItem>
            <DateRangePickerItem
                key="lastWeek"
                value="lastWeek"
                from={firstDayOfLastWeek}
                to={lastDayOfLastWeek}
            >
                Last Week
            </DateRangePickerItem>
            <DateRangePickerItem
                key="allTime"
                value="allTime"
                from={allTime}
                to={today}
            >
                All Time
            </DateRangePickerItem>
        </DateRangePicker>
    );
}